<ap-dynforms  [caption]="caption" [loading$]="loading$">
  <div dynforms.before>
    <div *ngIf="errorLoading" class="ap-error" style="margin-top:20%; text-align: center">{{'Lbl_FailToShowPdf' | translate}}
      <a [href]="secureUrl" [download]="filename" target="_blank"  id="download-failed-pdf">{{secureUrl}}</a>
    </div>
    <pdf-viewer (error)="onError()"
                (page-rendered)="pageRendered()"
                [original-size]="true"
                [show-all]="true"
                [external-link-target]="'blank'"
                [src]="secureUrl"
                [zoom]="zoom"
                [render-text]="true"
                style="display: block">
    </pdf-viewer>
  </div>
  <div class="ap-form-actions" dynforms.action *ngIf="showDownloadButton || showZoomButtons">
    <button id="zoom-out" *ngIf="showZoomButtons"
            kendoButton
            type="button"
            [svgIcon]="ApKendoIconService.Get('plusIcon')"
            class="k-button k-primary ap-form-button-left"
            (click)="zoomIn()"></button>
    <button id="zoom-in" *ngIf="showZoomButtons"
            kendoButton
            type="button"
            [svgIcon]="ApKendoIconService.Get('minusIcon')"
            class="k-button k-primary ap-form-button-left"
            (click)="zoomOut()"></button>
    <a [href]="secureUrl" [download]="filename" target="_blank"  id="download-pdf" *ngIf="showDownloadButton"
       class="k-button k-primary ap-form-button-right">{{'Global__Save_PDF' | translate}}</a>
  </div>
</ap-dynforms>



